import { Component, OnInit, ViewContainerRef, ViewChild, ComponentFactoryResolver, OnDestroy, ViewRef } from '@angular/core';
import { UserInterfaceService } from './shared/services/user-interface.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from './shared/services/config.service';
import { NavigationModel } from './shared/models/navigation.model';
import { BaseSidenavComponent } from './shared/base/base-sidenav.component';
import { BaseToolbarComponent } from './shared/base/base-toolbar.component';
import { ConnectionStatusEnum } from './shared/enums/connection.status.enum';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppInjector } from './app.injector';
import { AuthService } from './shared/services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  sidenavLeftStatus: Boolean = false;
  sidenavLeftSubscription: Subscription;
  sidenavRightStatus: Boolean = false;
  sidenavRightSubscription: Subscription;
  connectionStatus: ConnectionStatusEnum = ConnectionStatusEnum.None;

  private sidenavComponentSubscription: Subscription;
  private toolbarComponentSubscription: Subscription;

  private snackBar: MatSnackBar;

  @ViewChild('sidenavTarget', { read: ViewContainerRef, static: true }) sidenavTarget: ViewContainerRef;
  @ViewChild('toolbarTarget', { read: ViewContainerRef, static: true }) toolbarTarget: ViewContainerRef;

  constructor(
    private userInterfaceService: UserInterfaceService,
    private translateService: TranslateService,
    private configService: ConfigService,
    private cfr: ComponentFactoryResolver,
    private authService: AuthService)
  {
    this.snackBar = AppInjector.get(MatSnackBar);
  }

  ngOnInit() {

    this.sidenavLeftSubscription = this.userInterfaceService.getSidenavLeft().subscribe(result => {
      this.sidenavLeftStatus = result;
    });

    this.sidenavRightSubscription = this.userInterfaceService.getSidenavRight().subscribe(result => {
      this.sidenavRightStatus = result;
    });

    this.sidenavComponentSubscription = this.userInterfaceService.getSidenavComponent().subscribe(result => {
      this.resolveSidenav(result);
    });

    this.toolbarComponentSubscription = this.userInterfaceService.getToolbarComponent().subscribe(result => {
      this.resolveToolbar(result);
    });

     var languages = this.configService.getSupportedLanguages();
     var localLang = this.translateService.getBrowserLang();
     var index = languages.findIndex(i => i.value == localLang);
     if (index > 0) {
       this.translateService.setDefaultLang(languages[index].value);
       this.translateService.use(languages[index].value);
       this.userInterfaceService.setLanguage(languages[index].value);
     }
     else {
       var defaultLanguage = this.configService.getDefaultLanguage();
       this.translateService.setDefaultLang(defaultLanguage);
       this.translateService.use(defaultLanguage);
       this.userInterfaceService.setLanguage(defaultLanguage);
     }

  }

  ngOnDestroy(): void {
    this.sidenavLeftSubscription.unsubscribe();
    this.sidenavRightSubscription.unsubscribe();
    this.sidenavComponentSubscription.unsubscribe();
    this.toolbarComponentSubscription.unsubscribe();
  }

  private resolveSidenav(navigation: NavigationModel) {
    const factory = this.cfr.resolveComponentFactory(navigation.component);
    this.sidenavTarget.clear();
    var viewRef = this.sidenavTarget.createComponent(factory);
    if (navigation.data) {
      (<BaseSidenavComponent>viewRef.instance).data = navigation.data;
    }
  }

  private resolveToolbar(navigation: NavigationModel) {
    const factory = this.cfr.resolveComponentFactory(navigation.component);
    this.toolbarTarget.clear();
    var viewRef = this.toolbarTarget.createComponent(factory);
    if (navigation.data) {
      (<BaseToolbarComponent>viewRef.instance).data = navigation.data;
    }
  }

  public sidenavLeftClosed() {
    if (this.sidenavLeftStatus == true)
      this.userInterfaceService.setSidenavLeft(false);
  }

  public sidenavLeftOpened() {
    if (this.sidenavLeftStatus == true)
      this.userInterfaceService.setSidenavRight(false);
  }

  public sidenavRightClosed() {
    if (this.sidenavRightStatus == true)
      this.userInterfaceService.setSidenavRight(false);
  }

  public sidenavRightOpened() {
    if (this.sidenavRightStatus == true)
      this.userInterfaceService.setSidenavLeft(false);
  }

  private openSnackBar(message: string) {
    this.translateService.get(message).subscribe(result => {
      this.snackBar.open(result, 'OK', {
        duration: 5000,
      });
    });
  }

}
